"use client";

import { useProfileMe } from "@myaccount/profile/_client/hooks";
import { useI18n } from "@wojo/localization";
import { Card, Markdown, Text } from "@wojo/ui";
import { getCurrency } from "@wojo/web-components";
import styles from "./LoyaltyBenefitsCard.module.scss";

export const LoyaltyBenefitsCard: React.FC = () => {
    const { customer } = useProfileMe();
    const { formattedPrice, price } = getCurrency();
    const benefitsI18n = useI18n("account").account.loyalty.loyaltyBenefitsCard;

    if (!benefitsI18n) {
        return null;
    }

    const repeatDiscountFormatted = formattedPrice(
        customer?.loyaltyLevel?.repeatDiscount?.value ?? [],
    );
    const returnWindowDiscount = price(
        customer?.loyaltyLevel?.returnWindowDiscount?.value ?? [],
    );
    const returnWindowDiscountFormatted = formattedPrice(
        customer?.loyaltyLevel?.returnWindowDiscount?.value ?? [],
    );
    const repeatPromoCode = customer?.loyaltyLevel?.repeatPromoCode;

    return (
        <Card
            style={{
                marginBottom: "var(--g-spacing-xl)",
            }}
        >
            <div className={styles.group}>
                <Text.Body
                    emphasis={
                        benefitsI18n.repeatDiscount.description.l()
                            ? "none"
                            : "1"
                    }
                    style={{
                        marginBottom: "var(--g-spacing-sm)",
                    }}
                >
                    {benefitsI18n.repeatDiscount.title.l()}
                </Text.Body>
                <Text.Heading
                    tag="p"
                    order="4"
                    style={{
                        marginBottom: "var(--g-spacing-sm)",
                    }}
                >
                    {repeatDiscountFormatted}
                </Text.Heading>
                <Text.Body>
                    {benefitsI18n.repeatDiscount.description.l()}
                </Text.Body>
            </div>
            <div className={styles.group}>
                <Text.Body
                    style={{
                        marginBottom: "var(--g-spacing-sm)",
                    }}
                >
                    {benefitsI18n.returnWindowDiscount.title.l()}
                </Text.Body>
                <Text.Heading
                    tag="p"
                    order="4"
                    style={{
                        marginBottom: "var(--g-spacing-sm)",
                    }}
                >
                    {returnWindowDiscountFormatted}
                </Text.Heading>
                <Text.Body>
                    {returnWindowDiscount.value
                        ? benefitsI18n.returnWindowDiscount.description.l()
                        : benefitsI18n.returnWindowDiscount.noValueDescription.l()}
                </Text.Body>
            </div>
            {repeatPromoCode && (
                <Markdown
                    markdown={benefitsI18n.description.l({
                        promoCode: repeatPromoCode,
                    })}
                    linksAreExternal
                />
            )}
        </Card>
    );
};
